import React, { Component } from 'react';
import { withRouter } from './withRouter.js';
import {Container, Jumbotron, Row, Col, Card, Button } from 'react-bootstrap';
import { FiExternalLink } from "react-icons/fi";
import ta from './img/zzx.png'
import tah from './img/zzx-1.png'
import fumengh from './img/fumeng-1.png'

class People extends Component { 
    constructor(props) {
        super(props);
        this.state = {
            fumengHovered: false,
            huyHovered: false
        };
    }

    render(){
        return(
            <>
            <h2 id='crew'> Teaching crew</h2>
            <Row>
                <Card className='people-card'>
                   <Card.Img 
                       variant="top" 
                       src={this.state.fumengHovered ? 
      
                           "https://www.fmyang.com/img/FumengYang-2024-2-lg.jpg":fumengh
                       }
                       onMouseEnter={() => this.setState({fumengHovered: true})}
                       onMouseLeave={() => this.setState({fumengHovered: false})}
                   />
                   <Card.Body>
                     <Card.Title><a href="https://www.fmyang.com" target='_blank' className='normal-a'>Fumeng Yang <FiExternalLink /></a></Card.Title>
                     <Card.Text>
                     Instructor<br/>
                     Pronouns: she/her <br/>
                     Hours: W after class to 4:30p<br/>
                     Office: IRB 5138
                     </Card.Text>
                   </Card.Body>
                </Card>

                <Card className='people-card'>
                   <Card.Img 
                       variant="top" 
                       src={this.state.taHovered ? 
                           ta: tah
                       }
                       onMouseEnter={() => this.setState({taHovered: true})}
                       onMouseLeave={() => this.setState({taHovered: false})}
                   />
                   <Card.Body>
                     <Card.Title><a href='https://lebretou.github.io/' target='_blank' className='normal-a'>Zhongzheng Xu <FiExternalLink /></a></Card.Title>
                     <Card.Text>
                     Teaching Assistant<br/>
                     Pronouns: he/him <br/>
                     Hours: W 1-2pm <br/>
                     Zoom: see Canvas
                     </Card.Text>
                   </Card.Body>
                </Card>
             </Row>
             </>
        )
    }
}

export default People;